module.exports = __webpack_public_path__ + "img/D202310_3.5e4a0980.jpg";